/**
 * Harral's Spawnblade (28): coalesce weapon grant flies into one sequential batch per route.
 */
export function coalesceHarralSpawnbladeWeaponGrantFlyBatch(grants) {
  if (!grants?.length) {
    return [];
  }

  const passthrough = [];
  const grantGroups = new Map();

  grants.forEach((grant) => {
    if (grant?.source !== 'harral_spawnblade_28' || !grant?.key) {
      passthrough.push(grant);
      return;
    }
    const keyParts = String(grant.key).split(':');
    if (keyParts.length < 4) {
      throw new Error(`coalesceHarralSpawnbladeWeaponGrantFlyBatch: invalid grant key ${grant.key}`);
    }
    const spawnbladeInstanceId = keyParts[1];
    const targetInstanceId = keyParts[2];
    const groupKey = `${spawnbladeInstanceId}:${targetInstanceId}:${grant.fromZone}:${grant.fromIndex}:${grant.toZone}:${grant.toIndex}`;
    if (!grantGroups.has(groupKey)) {
      grantGroups.set(groupKey, []);
    }
    grantGroups.get(groupKey).push(grant);
  });

  grantGroups.forEach((group) => {
    const sorted = [...group].sort(
      (a, b) => (a.sequenceIndex ?? 0) - (b.sequenceIndex ?? 0)
    );
    if (sorted.length === 1) {
      passthrough.push(sorted[0]);
      return;
    }
    const keyParts = String(sorted[0].key).split(':');
    const spawnbladeInstanceId = keyParts[1];
    const targetInstanceId = keyParts[2];
    const batchWeaponInstanceIds = sorted.map((g) => String(g.weaponInstanceId));
    passthrough.push({
      ...sorted[0],
      key: `harral-28-batch:${spawnbladeInstanceId}:${targetInstanceId}:${batchWeaponInstanceIds.join('_')}`,
      batchGrants: sorted,
      batchWeaponInstanceIds,
    });
  });

  return passthrough;
}
